import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./FeedsHubPage.css";

const feedSections = [
  {
    title: "Vídeo e social",
    description: "Descubra vídeos curtos, transmissões e entretenimento.",
    items: [
      { name: "Vídeos Curtos", path: "/tiktok", tag: "VC" },
      { name: "Vídeos Longos", path: "/youtube", tag: "VL" },
      { name: "Reels", path: "/reels", tag: "RL" },
      { name: "Shorts", path: "/shorts", tag: "SH" },
      { name: "Streaming", path: "/netflix", tag: "ST" },
      { name: "Movie Portal", path: "/movie-portal", tag: "MV" },
      { name: "Video Bank", path: "/video-bank", tag: "VB" },
      { name: "Gaming", path: "/gaming", tag: "GM" },
      { name: "Esports", path: "/esports", tag: "ES" },
      { name: "Game Review", path: "/game-review", tag: "GR" },
      { name: "Audio", path: "/audio", tag: "AU" },
      { name: "Músicas", path: "/spotify", tag: "MS" },
      { name: "Live Audio", path: "/live-audio", tag: "LA" },
      { name: "Live Stream", path: "/live-stream", tag: "LS" },
      { name: "Conversas", path: "/threads", tag: "CV" },
      { name: "GIFs", path: "/gif", tag: "GF" },
      { name: "Stickers", path: "/sticker", tag: "ST" },
    ],
  },
  {
    title: "Notícias e conteúdo",
    description: "Podcasts, blogs e acervos para leitura.",
    items: [
      { name: "Notícias", path: "/cnn", tag: "NT" },
      { name: "Blog", path: "/blog", tag: "BG" },
      { name: "Podcast", path: "/podcast", tag: "PC" },
      { name: "Portfolio", path: "/portfolio", tag: "PF" },
      { name: "Biblioteca", path: "/library", tag: "LB" },
      { name: "E-books", path: "/ebook", tag: "EB" },
      { name: "PDFs", path: "/pdf", tag: "PD" },
    ],
  },
  {
    title: "Educação",
    description: "Cursos, quizzes e materiais de estudo.",
    items: [
      { name: "Courses", path: "/course", tag: "CR" },
      { name: "Quiz", path: "/quiz", tag: "QZ" },
      { name: "Tutoriais", path: "/tutorial", tag: "TT" },
      { name: "Estudante", path: "/estudent", tag: "ED" },
      { name: "Escola", path: "/school", tag: "SC" },
      { name: "Votação", path: "/voting", tag: "VT" },
    ],
  },
  {
    title: "Serviços e comércio",
    description: "Compras, mobilidade e reservas.",
    items: [
      { name: "E-Shop", path: "/eshop", tag: "ES" },
      { name: "Marketplace", path: "/aliexpress", tag: "MK" },
      { name: "Restaurantes", path: "/restaurant", tag: "RS" },
      { name: "Delivery", path: "/food-delivery", tag: "FD" },
      { name: "Booking", path: "/booking", tag: "BK" },
      { name: "Hospedagem", path: "/airbnb", tag: "HP" },
      { name: "Aluguel", path: "/rental", tag: "RT" },
      { name: "Mobilidade", path: "/uber", tag: "MB" },
      { name: "Serviços", path: "/job-service", tag: "JS" },
      { name: "Eventos", path: "/event", tag: "EV" },
      { name: "Classificados", path: "/classified", tag: "CL" },
    ],
  },
  {
    title: "Comunidade e causas",
    description: "Projetos sociais, campanhas e voluntariado.",
    items: [
      { name: "Comunidade", path: "/community", tag: "CM" },
      { name: "Petição", path: "/petition", tag: "PT" },
      { name: "Crowdfunding", path: "/crowdfunding", tag: "CF" },
      { name: "ONG", path: "/ong", tag: "OG" },
      { name: "Saúde", path: "/medical", tag: "MD" },
    ],
  },
  {
    title: "Lifestyle e bem-estar",
    description: "Viagens, esportes e estilo de vida.",
    items: [
      { name: "Viagens", path: "/travel", tag: "TR" },
      { name: "Automóveis", path: "/car", tag: "CR" },
      { name: "Yoga", path: "/yoga", tag: "YG" },
      { name: "Exercícios", path: "/exercise", tag: "EX" },
      { name: "Receitas", path: "/recipe", tag: "RC" },
      { name: "Moda", path: "/fashion", tag: "FS" },
      { name: "Beleza", path: "/beauty", tag: "BL" },
    ],
  },
];

export default function FeedsHubPage() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [navigate, user]);

  if (!user) {
    return null;
  }

  return (
    <div className="feeds_hub_page">
      <header className="feeds_hub_header">
        <div>
          <p className="feeds_hub_kicker">Central de feeds</p>
          <h1 className="feeds_hub_title">Escolha um feed para navegar</h1>
          <p className="feeds_hub_subtitle">
            Todos os feeds editoriais organizados por categoria.
          </p>
        </div>
        <div className="feeds_hub_header_actions">
          <Link to="/" className="feeds_hub_chip">Home</Link>
          <Link to="/chat" className="feeds_hub_chip">Chat</Link>
          <Link to="/profile" className="feeds_hub_chip">Perfil</Link>
        </div>
      </header>

      <div className="feeds_hub_sections">
        {feedSections.map((section) => (
          <section key={section.title} className="feeds_hub_section">
            <div className="feeds_hub_section_header">
              <div>
                <p className="feeds_hub_section_kicker">{section.title}</p>
                <h2 className="feeds_hub_section_title">{section.description}</h2>
              </div>
            </div>

            <div className="feeds_hub_grid">
              {section.items.map((item) => (
                <Link key={item.path} to={item.path} className="feeds_hub_card">
                  <span className="feeds_hub_card_tag">{item.tag}</span>
                  <div className="feeds_hub_card_body">
                    <span className="feeds_hub_card_title">{item.name}</span>
                    <span className="feeds_hub_card_hint">Acessar feed</span>
                  </div>
                  <span className="feeds_hub_card_arrow">→</span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
